import Endpoint from "@/utils/endPoint";

const klassEndpoint = new Endpoint("/klasses/");
const klassListEndpoint = new Endpoint("/klasses/summaries");
const klassWithIdEndpoint = new Endpoint("/klasses/{klassId}");
const deactiveEndpoint = new Endpoint("/klasses/{klassId}/deactivate");
const klassIntroEndpoint = new Endpoint("/klasses/{klassId}/introduction");

class KlassService {
    async createKlassService(params) {
        const result = await klassEndpoint.post(params);
        return result;
    }

    async getKlassListService(params) {
        const result = await klassListEndpoint.get(params);
        return result;
    }

    async getKlassInfoService(params) {
        const result = await klassWithIdEndpoint.get(params);
        return result;
    }

    async updateKlassInfoService(params) {
        const { klassId, ...param } = params
        const result = await klassWithIdEndpoint.put(param, { klassId });
        return result;
    }

    async getKlassIntroService(params) {
        const result = await klassIntroEndpoint.get(params);
        return result;
    }

    async updateKlassIntroService(params) {
        const { klassId, ...param } = params
        const result = await klassIntroEndpoint.put(param, { klassId });
        return result;
    }

    async deactiveService(params) {
        const { klassId, ...param } = params
        const result = await deactiveEndpoint.put(param, { klassId });
        return result;
    }
}

export default new KlassService();
